<div id="admin-wrapper">
  <app-header-mobile *hideItBootstrap="['lg','xl', 'xxl']"></app-header-mobile>
  <app-sidebar-left *showItBootstrap="['lg','xl', 'xxl']"></app-sidebar-left>

  <div class="container">
    <router-outlet></router-outlet>
  </div>

  <app-sidebar-right *showItBootstrap="['lg','xl', 'xxl']"></app-sidebar-right>
  <app-navigation-mobile *hideItBootstrap="['lg','xl', 'xxl']"></app-navigation-mobile>
</div>

